import { useState, useEffect } from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';
import EditOrgInfoForm from '../../profile/components/manage-organization/EditOrgInfoForm';
import OrgLogoModule from './OrgLogoModule';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';


function OrgInfoDisplay({ 
	mode, 
	// Redux
	adminOrgProfile, 
	isMobileView, 
	manageAdminOrgProfileOutcome, 
	// dsrBrandingOptions, 
	// applyBranding 
}) {
	
	const [showEditOrgInfoModal, setShowEditOrgInfoModal] = useState(false);

	const [isAdmin, setIsAdmin] = useState(false)
	const [orgProfile, setOrgProfile] = useState(null)
	// const [brandColors, setBrandColors] = useState(null);

	const [orgName, setOrgName] = useState("")
	const [orgLogo, setOrgLogo] = useState("")
	const [orgDescription, setOrgDescription] = useState("")
	const [orgRegisteredCountry, setOrgRegisteredCountry] = useState("")
	const [orgRegisteredAddress, setOrgRegisteredAddress] = useState("")
	const [orgRegisteredName, setOrgRegisteredName] = useState("")
	const [orgRegisteredNumber, setOrgRegisteredNumber] = useState("")

	useEffect(() => {
		if (adminOrgProfile) {
			const { isAdministrator, orgId, orgName, orgLogo, orgDescription, orgRegisteredCountry, orgRegisteredAddress, orgRegisteredName, orgRegisteredNumber } = adminOrgProfile || {}
			const orgProfile = { orgId, orgName, orgDescription, orgRegisteredCountry, orgRegisteredAddress, orgRegisteredName, orgRegisteredNumber };

			setIsAdmin(isAdministrator)
			setOrgName(orgName)
			setOrgLogo(orgLogo)
			setOrgDescription(orgDescription)
			setOrgRegisteredCountry(orgRegisteredCountry)
			setOrgRegisteredAddress(orgRegisteredAddress)
			setOrgRegisteredName(orgRegisteredName)
			setOrgRegisteredNumber(orgRegisteredNumber)
			setOrgProfile(orgProfile)
		}

	}, [adminOrgProfile])

	
	// TODO: For future scope of applying branding color highlights to UI appearahce
	// useEffect(() => {
	// 	if (!!applyBranding && dsrBrandingOptions) {
	// 		setBrandColors(dsrBrandingOptions)
	// 	}
	// }, [applyBranding, dsrBrandingOptions]);


	useEffect(() => {
		if (manageAdminOrgProfileOutcome) {
			const { updatedSuccessfully, updatedAdminOrgProfile } = manageAdminOrgProfileOutcome || {};

			if (updatedSuccessfully === true) {
				const { isAdmin, orgName, orgLogo, orgDescription, orgRegisteredCountry, orgRegisteredAddress, orgRegisteredName, orgRegisteredNumber } = updatedAdminOrgProfile || {}
		
				setIsAdmin(isAdmin)
				setOrgName(orgName)
				setOrgLogo(orgLogo)
				setOrgDescription(orgDescription)
				setOrgRegisteredCountry(orgRegisteredCountry)
				setOrgRegisteredAddress(orgRegisteredAddress)
				setOrgRegisteredName(orgRegisteredName)
				setOrgRegisteredNumber(orgRegisteredNumber)
				setShowEditOrgInfoModal(false)
			}
		}

	}, [manageAdminOrgProfileOutcome, adminOrgProfile])

	if (mode === "billing") {
		return (

			<Box>
				<Flex direction={['column', 'row', 'row', 'row']} justify='space-between' pt='1.5em'>
					<Box flex='1 1 0' w='100%'>
						<Text color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>
							Legal entity name
						</Text>
						<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>{orgRegisteredName ? orgRegisteredName : "-"}</Text>

						<Text mt='2em' color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>
							Country incorporated
						</Text>
						<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>{orgRegisteredCountry ? orgRegisteredCountry : '-'}</Text>
					</Box>

					<Box flex='1 1 0' mt={['2em', '0', '0', '0']} pl={['0em', '1em', '1em', '1em']}>
						<Text color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>
							Registration number
						</Text>
						<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>{orgRegisteredNumber ? orgRegisteredNumber : "-"}</Text>

						<Text mt='2em' color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={isMobileView && 'center'}>
							Registered address
						</Text>
						<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' textAlign={isMobileView && 'center'}>{orgRegisteredAddress ? orgRegisteredAddress : "-"}</Text>
					</Box>

				</Flex>

			</Box>
		);
	} else {
		if (isMobileView) {
			return <Flex direction='column' justify='center' align='center' w='100%' py='1em'>

				<Box mt={['0','2em']}>
					<OrgLogoModule
						isAdmin={isAdmin}
						orgName={orgName}
						orgLogo={orgLogo}
					/>

				</Box>
				{orgName && <Box fontSize='1.25em' lineHeight='1.875em' color='brandDark.500'>{orgName} </Box>}


				<Flex direction={['column', 'column', 'row', 'row']} justify={['center', 'center', 'space-between', 'space-between']}>
					<Box flex='1 1 0' mt={['2em', '0', '0', '0']} pl={['0em', '1em', '1em', '1em']}>
						<Text color='gray.500' fontSize='0.875em' lineHeight='1.25em' textAlign={['center', 'center', 'left', 'left']}>About</Text>
						<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' className="white-space-preline">{orgDescription ? orgDescription : "-"}</Text>

					</Box>
				</Flex>

				<Flex mt='3em' w='100%' px='1em' >
					<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => setShowEditOrgInfoModal(true)} label='Edit' />
				</Flex>

				<LaunchdeckModal
					title='Edit Organization'
					handleCloseModal={() => setShowEditOrgInfoModal(false)}
					showModal={showEditOrgInfoModal}
				>
					<EditOrgInfoForm
						orgProfile={orgProfile}
						handleCloseModal={() => setShowEditOrgInfoModal(false)}
					/>
				</LaunchdeckModal>

			</Flex>
		} else {
			return (

				<Box>
					<Box>
						<Flex>
							<Box flex='1 0 auto' position='relative'>
								<Box maxWidth='100em' w='100%' height='8em' 
								// bg={applyBranding && brandColor ? brandColor :'brandDark.500'}
								bg='brandDark.500'  
								rounded='0.25em' />
								<Flex mt='0.4em' justify='flex-start' align='center' position='absolute' bottom='-2em' left='1.5em'>
									<OrgLogoModule
										isAdmin={isAdmin}
										orgName={orgName}
										orgLogo={orgLogo}
									/>
									<Box color='gray.50' fontSize='1.25em' lineHeight='1.875em' pl='1em'>{orgName ? orgName : "Organization Name"} </Box>
								</Flex>
							</Box>
						</Flex>

					</Box>

					<Flex w='100%' justify='flex-end' pt='1em'>
						<LaunchdeckButton color='white' bg='brand.500' fontWeight='500' cursor='pointer' label='Edit' onClick={() => setShowEditOrgInfoModal(true)} />
					</Flex>

					<Flex direction={['column', 'row', 'row', 'row']} justify='space-between' mt='3em' pt='1.5em'>
						<Box flex='1 1 0' mt={['2em', '0', '0', '0']} pl={['0em', '1em', '1em', '1em']}>
							<Text color='gray.500' fontSize='0.875em' lineHeight='1.25em'>About</Text>
							<Text mt='0.5em' lineHeight='1.375em' fontWeight='400' className="white-space-preline">{orgDescription ? orgDescription : "-"}</Text>

						</Box>
					</Flex>

					<LaunchdeckModal
						title='Edit Organization'
						handleCloseModal={() => setShowEditOrgInfoModal(false)}
						showModal={showEditOrgInfoModal}
						maxW='35em'
					>
						<EditOrgInfoForm
							orgProfile={orgProfile}
							handleCloseModal={() => setShowEditOrgInfoModal(false)}
						/>
					</LaunchdeckModal>
				</Box>
			);
		}

	}

}

function mapStateToProps(state) {
	return {
		adminOrgProfile: state.adminOrgProfile.results.data,
    // dsrBrandingOptions: state.dsrBrandingOptions.results,
    // applyBranding: state.dsrApplyBranding.results,
		manageAdminOrgProfileOutcome: state.manageAdminOrgProfileOutcome.results.data,
		isMobileView: state.mobileViewMode.isMobileView
	};
}


export default withRouter(connect(mapStateToProps, null)(OrgInfoDisplay));